// Manager Portal Pie Chart Colors - Exact Match
export const projectColors = [
  'rgba(92, 123, 199, 1)',     // Medium Blue (from manager pie chart)
  'rgba(139, 195, 143, 1)',    // Soft Green (from manager pie chart)
  'rgba(255, 99, 132, 0.9)',   // Dark Pink/Red
  'rgba(102, 187, 106, 0.9)',  // Dark Mint Green
  'rgba(153, 102, 255, 0.9)',  // Dark Purple
  'rgba(255, 159, 64, 0.9)',   // Dark Orange
  'rgba(240, 98, 146, 0.9)',   // Dark Rose
  'rgba(77, 182, 172, 0.9)',   // Dark Cyan
  'rgba(186, 104, 200, 0.9)',  // Dark Violet
  'rgba(255, 138, 101, 0.9)',  // Dark Coral
  'rgba(174, 213, 129, 0.9)',  // Dark Lime
  'rgba(255, 112, 166, 0.9)',  // Dark Magenta
  'rgba(149, 117, 205, 0.9)',  // Dark Deep Purple
  'rgba(255, 204, 128, 0.9)',  // Dark Peach
  'rgba(129, 199, 132, 0.9)',  // Dark Green
  'rgba(255, 183, 77, 0.9)',   // Dark Amber
  'rgba(255, 99, 71, 0.9)',    // Dark Tomato
  'rgba(179, 157, 219, 0.9)',  // Dark Lavender
  'rgba(240, 128, 128, 0.9)',  // Dark Light Coral
  'rgba(221, 160, 221, 0.9)',  // Dark Plum
];

// Store generated colors to maintain consistency
const colorMap = new Map();

export const getProjectColor = (projectId) => {
  if (!colorMap.has(projectId)) {
    // Use a consistent color from the palette based on project ID
    const index = typeof projectId === 'number' 
      ? projectId % projectColors.length 
      : Math.abs(String(projectId).split('').reduce((acc, char) => acc + char.charCodeAt(0), 0)) % projectColors.length;
    colorMap.set(projectId, projectColors[index]);
  }
  return colorMap.get(projectId);
}; 